import { Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientModule } from 'src/app/constantes/client-modules.constantes';
import { ClientService } from 'src/app/services/client/client.service';
import { AutorisationAggregate } from '../../../../../aggregats/autorisation/autorisation.aggregate';
import { AutorisationsAggregate } from '../../../../../aggregats/autorisation/autorisations.aggregate';
import { SousMenuItemAggregate } from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import { FonctionLogicielle } from '../../../../fonctions-logicielle-constantes';
import { EparcoursPath } from '../../eparcours-path';

export const formationsCatalogueSousMenuItem = new SousMenuItemAggregate(
  'Formations / Catalogue',
  `/${EparcoursPath.root.FORMATIONS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.FormationsCatalogue)]),
);

export const sessionsSousMenuItem = new SousMenuItemAggregate(
  'Sessions / Parcours',
  `/${EparcoursPath.root.SESSIONS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.PlanificationSessions)]),
);


export const planningFormateursSousMenuItem = new SousMenuItemAggregate(
  'Planning Formateurs',
  `/${EparcoursPath.root.PLANNING_FORMATEURS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.PlanningFormateurs)]),
);

export const inscriptionsSousMenuItem = new SousMenuItemAggregate(
  'Inscriptions',
  `/${EparcoursPath.root.INSCRIPTIONS_FORMATION}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Inscriptions)]),
);

export const planningRessourcesSousMenuItem = new SousMenuItemAggregate(
  'Planning Ressources',
  `/${EparcoursPath.root.PLANNING_RESSOURCES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.PlanningRessources)]),
);


export function buildSessionsSousMenuItem(injector: Injector): Observable<SousMenuItemAggregate> {
  const clientService = injector.get(ClientService);

  return clientService.loadClientModules().pipe(
    map((modules) => {
      const hasParcoursComposes = modules.some(m => m.code === ClientModule.ParcoursComposes || m.code === ClientModule.ParcoursSimple);
      const libelle = hasParcoursComposes ? 'Sessions / Parcours' : 'Sessions';

      return new SousMenuItemAggregate(
        libelle,
        `/${EparcoursPath.root.SESSIONS}`,
        new AutorisationsAggregate([
          new AutorisationAggregate(FonctionLogicielle.PlanificationSessions),
        ]),
      );
    })
  );
}
